<template>
  <v-container class="sign-in">
    <v-layout>
      <v-flex>
        <template v-for="({ name, data }) in componentOrder">
          <template v-if="name === 'PasswordForgot'">
            <component
              :is="'LoginAdditionalAction'"
              :key="name"
              :label="$t('signIn.forgot-password')"
              :as-link="true"
              :urlPath="{ name: 'forgot-password' }"
            />
          </template>
          <template v-else-if="name === 'LanguagePicker'">
            <component
              :is="'LoginAdditionalAction'"
              :key="name"
              :label="$t('signIn.choose-language')"
              @click.native="languageSelectOpen = true"
            />
          </template>
          <template
            v-else-if="name === 'AppPage' || name === 'PageComponent'"
          >
            <page-component :key="name" :data="data" />
          </template>
          <component v-else :is="name" :key="name" />
        </template>
      </v-flex>
    </v-layout>
    <language-select
      v-model="languageSelectOpen"
      @close="languageSelectOpen = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'
import LoginBox from '@/components/auth/LoginBox'
import LoginAdditionalAction from '@/components/auth/LoginAdditionalAction'
import LanguageSelect from '@/components/LanguageSelect'
import PageComponent from '@/components/PageComponent'

export default {
  name: 'Signin',
  components: {
    LoginBox,
    LoginAdditionalAction,
    LanguageSelect,
    PageComponent
  },
  data() {
    return {
      defaultComponentOrder: [{name: 'LoginBox'}],
      languageSelectOpen: false,
    }
  },
  computed: {
    ...mapGetters(['appScreens']),
    componentOrder() {
      return _.get(this.appScreens, 'login.components', false) ||
        this.defaultComponentOrder
    }
  },
}
</script>

<style lang="scss" scoped>
.sign-in {
  max-width: 570px;
}
</style>
